import React from 'react';
import {LinkVideoStage} from '../../../types'

type Props = {
  children?: React.ReactNode;
  link?: LinkVideoStage;
}

const Link = (props: Props): JSX.Element => {
  const {children, link} = props;
  const {
    url,
    text,
    id,
    role,
    mail_text: mailText,
    mail_cc: mailCc,
    mail_bcc: mailBcc,
    mail_subject: mailSubject,
    mail_to: mailTo,
    aria_label: ariaLabel,
    iconClass,
    notice,
    template_uid: templateUid
  } = link ?? {};
  const target: string | undefined = templateUid === "external_link_plain" ? "_blank" : undefined;
  const rel: string | undefined = target ? "noopener noreferrer" : undefined;

  const buildMailToHref = (): string => {
    let seperatorCounter = 0;
    const getSeperatorAndPart = (part: string | undefined): string => {
      if (!part) {
        return '';
      }
      seperatorCounter += seperatorCounter;
      return seperatorCounter === 1 ? `?${part}` : `&${part}`;
    }
    return `mailto:${mailTo}${getSeperatorAndPart(mailCc)}${getSeperatorAndPart(mailBcc)}${getSeperatorAndPart(mailSubject)}${getSeperatorAndPart(mailText)}`
  }

  return (
    <a
      aria-label={ariaLabel}
      href={mailTo ? buildMailToHref() : url}
      target={target}
      id={id}
      role={role}
      rel={rel}
      className="link-headline"
    >
      {children}
      <p>
        <span className={`${iconClass?.join(' ') || 'ic-arrowRight'}`}/>
        <span className="link__name">
          <span className="link__name-inner">
            <span className="link__name-text">{text}</span>
            {notice && <span className="link__notice">{notice}</span>}
          </span>
        </span>
      </p>
    </a>
  );
}

export default Link;
